import { Divider } from '@cerifi/ui/components/divider'

interface EnrollmentHeaderProps {
  tag: string
}

export const EnrollmentHeader = (props: EnrollmentHeaderProps) => (
  <div className="py-6 sm:pb-0 sm:pt-20">
    <h1 className="text-sm font-medium">{props.tag}</h1>

    <Divider className="mb-12 mt-6 hidden sm:block" />
  </div>
)
